export const BASE_PATH = '';
export const LOGIN_ROUTE = '/login';
export const APPLY_ROUTE = '/apply';
export const UPDATES_ROUTE = '/contact/updates';
export const PAYMENT_PROVIDER = 'PAYFAST';
export const SUPPORT_EMAIL = 'info@schoolofshem.com';
export const PHONE_DISPLAY = '+27 61 587 1145';
export const WHATSAPP_NUMBER = '27615871145';
export const MAP_EMBED_URL = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d0!2d0!3d0!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0!2sSchool%20of%20Shem!5e0!3m2!1sen!2sza!4v0000000000'; // Replace with real embed URL
export const MAPS_URL = 'https://maps.google.com/?q=2%20Selbourne%20Rd%20Fourways%2C%20Block%20808%20Hammets%20Crossing%20Office%20Park%2C%20Johannesburg%20South%20Africa';
export const LOCATION_ADDRESS = '2 Selbourne Rd, Fourways, Block 808 Hammets Crossing Office Park, Johannesburg, South Africa';
export const ALUMNI_ROUTE = '/alumni';
export const STUDENTS_ROUTE = '/students';
export const GIVE_ROUTE = '/partnerships';

export const withBase = (path) => {
  if (!BASE_PATH) return path;
  if (path === '/') return BASE_PATH || '/';
  return `${BASE_PATH}${path}`;
};
